module.exports = __webpack_public_path__ + "static/media/contact.04411221.png";